module.exports = __webpack_public_path__ + "img/bg_ch.11cf4d9a.jpg";